import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

import { TaxiNav } from '@/components/TaxiNav';
import { ScreenWrapper } from '@/components/ScreenWrapper';
import GlobalContainer from '@/containers/GlobalContainer';
import Error from '@/pages/Error';
import TaxiAnalyticsDashboard from '@/pages/TaxiAnalyticsDashboard';
import TaxiInputDashboard from '@/pages/TaxiInputDashboard';
import TaxiSettings from '@/pages/TaxiSettings';
import { TaxiDataProvider } from '@/contexts/TaxiDataContext';

function App() {
	return (
		<ScreenWrapper>
			<RecoilRoot>
				<GlobalContainer>
					<TaxiDataProvider>
						<BrowserRouter>
							<TaxiNav />
							<Routes>
								<Route path="/" element={<TaxiInputDashboard />} />
								<Route path="/input" element={<TaxiInputDashboard />} />
								<Route path="/analytics" element={<TaxiAnalyticsDashboard />} />
								<Route path="/settings" element={<TaxiSettings />} />
								<Route path="*" element={<Error />} />
							</Routes>
						</BrowserRouter>
					</TaxiDataProvider>
				</GlobalContainer>
			</RecoilRoot>
		</ScreenWrapper>
	);
}

export default App;
